@for (ministry of ministries; track ministry) {
  <div>
    <zwi-sermon-category-row>{{ ministry.ministry }}</zwi-sermon-category-row>
    <zwi-sermon-list [sermons]="ministry.sermons" [sortBy]="'airDate'" (starChange)="favoriteChange($event)"></zwi-sermon-list>
  </div>
}
